import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://irvcomcbtpkqonbegmfc.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlydmNvbWNidHBrcW9uYmVnbWZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI0MTc4ODMsImV4cCI6MjA2Nzk5Mzg4M30.kR1WlTtYJ5Jlb2o_yo7wkOpxqDMbGiKoo42m03Eue20"; 

export const supabase = createClient(supabaseUrl, supabaseAnonKey);